<template>
    <UiButton class="UiButton" :blok="blok" />
</template>

<script setup>
defineProps({ blok: Object });
</script>

<style lang="postcss" scoped>
.UiButton {
    @apply bg-transparent;
}
</style>
